module.exports = __webpack_public_path__ + "img/OCR.df57992c.svg";